import type {EvaluationResponsePayload, Payload} from './interfaces'
import type {RequestConfig, RequestResponse} from '@datadog/datadog-ci-base/helpers/request'
import type {Writable} from 'stream'

import {datadogRoute} from '@datadog/datadog-ci-base/helpers/request/datadog-route'
import {getRequestBuilder} from '@datadog/datadog-ci-base/helpers/utils'

export const evaluateGateRules =
  (request: (args: RequestConfig) => Promise<RequestResponse<EvaluationResponsePayload>>) =>
  async (evaluateRequest: Payload, write: Writable['write']) => {
    const payload = JSON.stringify({
      data: {
        id: evaluateRequest.requestId,
        type: 'gate_evaluation',
        attributes: {
          tags: evaluateRequest.spanTags,
          user_scope: evaluateRequest.userScope,
          start_time_ms: evaluateRequest.startTimeMs,
          options: {
            no_wait: evaluateRequest.options.noWait,
            dry_run: evaluateRequest.options.dryRun,
            is_last_retry: evaluateRequest.options.isLastRetry,
            pull_request_sha: evaluateRequest.options.pull_request_sha,
          },
        },
      },
    })

    return request({
      data: payload,
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      url: datadogRoute('/api/v2/quality-gates/evaluate'),
    })
  }

export const apiConstructor = (baseIntakeUrl: string, apiKey: string, appKey: string) => {
  const serviceRequest = getRequestBuilder({baseUrl: baseIntakeUrl, apiKey, appKey})

  return {
    evaluateGateRules: evaluateGateRules(serviceRequest),
  }
}
